import { PARENT_WINDOW_SIZE } from 'scripts/type'

const isMdScreen = (size: PARENT_WINDOW_SIZE | null) => size === PARENT_WINDOW_SIZE.MD

export default isMdScreen
